export default __webpack_public_path__ + "static/media/TVS_Ntorq_125_catalogo.0dc5dc01.pdf";